<template>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import ButtonControlMixin from '../mixins/ButtonControlMixin';

    let sv = null;
    export default {
        mixins: [
            GlobalMixin,
            ButtonControlMixin
        ],
        data() {
            return {
                idPanel: 'expandcollapse',
                className: 'ol-expandcollapse',
                ignoreInitialState: true,
            }
        },
        methods: {
            addButtonMap: function(_map){
                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/dots.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: (evt) =>  {
                                this.toggleButtons($(evt.target));
                                evt.stopPropagation();
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                    let el = $(btn.element); if(el) el.hide()
                });
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                    let el = $(btn.element); if(el) el.show()
                });
                return btn;
            },
            toggleButtons: function(el) {
                let elements = el.closest('.ol-control-panel ').children(`.ol-control.${this.collapsibleClassName}:not(.${this.className})`);
                elements.toggle("slow");
            },
        }

    }
</script>